var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { getConfigVar } from "../../utils/Configuration";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";
var Collapse = /** @class */ (function (_super) {
    __extends(Collapse, _super);
    function Collapse(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () { return _this.handleCollapse(true); };
        _this.componentDidUpdate = function (prevProps) {
            if (prevProps.opened !== _this.props.opened)
                _this.toggleOpen(_this.props.opened);
        };
        _this.toggleOpen = function (value) { return _this.setState({ opened: value != null ? value : !_this.state.opened }, _this.handleCollapse); };
        _this.internalHandler = function () { return _this.handleCollapse(); };
        _this.handleCollapse = function (load) {
            if (load === void 0) { load = false; }
            var content = _this.accordion.children[1], opened = _this.state.opened, fn = function () { return content.style.maxHeight = opened ? content.scrollHeight + "px" : "0"; };
            if (!opened) {
                content.style.maxHeight = content.scrollHeight + "px";
                content.classList.add("closing");
                setTimeout(function () { return content.classList.remove("closing"); });
                _this.accordion.style.overflow = "hidden";
            }
            load ? fn() : setTimeout(fn);
            setTimeout(function () {
                if (opened) {
                    content.style.maxHeight = "100%";
                    _this.accordion.style.overflow = "unset";
                }
            }, 200);
        };
        _this.render = function () {
            var _a = _this.props, label = _a.label, children = _a.children, color = _a.color, className = _a.className, style = _a.style, opened = _this.state.opened, colorTmp = color !== null && color !== void 0 ? color : "blue";
            return React.createElement("div", { className: "dolfo-collapse color-" + colorTmp + (opened ? " opened" : "") + (className ? " " + className : ""), style: style, ref: function (r) { return _this.accordion = r; } },
                React.createElement("div", { className: "dolfo-collapse-title", onClick: function () { return _this.toggleOpen(); } },
                    React.createElement("strong", null, label),
                    React.createElement(Tooltip, { label: getConfigVar(opened ? "COLLAPSE" : "EXPAND") },
                        React.createElement(Button, { className: "dolfo-collapse-toggle", shape: "text", color: "dark" },
                            React.createElement(FontAwesomeIcon, { icon: faChevronLeft, className: opened ? "rotated" : "" })))),
                React.createElement("div", { className: "dolfo-collapse-content" },
                    React.createElement("div", { className: "dolfo-collapse-inner" }, children)));
        };
        _this.state = {
            opened: props.opened != null ? props.opened : false
        };
        return _this;
    }
    return Collapse;
}(React.Component));
export { Collapse };
